import type {ContentBlocksFragment} from '@/modules/foundation/sanity/content-blocks/query';
import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import {DOCUMENT_TYPE_BANK_GUIDEBOOK} from '../../../bank/guidebook/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_GUIDEBOOK} from '../../../collection/guidebook/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_GUIDEBOOK} from '../../../insurance/guidebook/sanity/constants';

import type {BLOCK_TYPE_GUIDEBOOK_LIST_ALL} from './constants';

export const GUIDEBOOK_LIST_ALL_FRAGMENT = `//groq
	...,
	description[]{
		${PORTABLE_TEXT_FRAGMENT}
	},
	"insurance": *[_type == "${DOCUMENT_TYPE_INSURANCE_GUIDEBOOK}"][0] {
		_type,
		title,
		"slug": slug.current
	},
	"bank": *[_type == "${DOCUMENT_TYPE_BANK_GUIDEBOOK}"][0] {
		_type,
		title,
		"slug": slug.current
	},
	"collection": *[_type == "${DOCUMENT_TYPE_COLLECTION_GUIDEBOOK}"][0] {
		_type,
		title,
		"slug": slug.current
	}
`;

export type GuidebookListAllFragment = Extract<
	ContentBlocksFragment[number],
	{_type: typeof BLOCK_TYPE_GUIDEBOOK_LIST_ALL}
>;
